import { MIN_HEADCOUNT_FOR_BENEFITS } from './prospects';
import { TRANSLATIONS_QUOTES } from '../translations/quotes';
import type { TobaccoStatus } from '../types/quotes';

export const TOBACCO_OPTIONS: { value: TobaccoStatus; labelKey: string }[] = [
  { value: 'non_tobacco', labelKey: TRANSLATIONS_QUOTES.create.tobacco.nonTobacco },
  { value: 'tobacco', labelKey: TRANSLATIONS_QUOTES.create.tobacco.tobacco }
];

export const MIN_EMPLOYEES_FOR_QUOTES = MIN_HEADCOUNT_FOR_BENEFITS;

/** App only places no insurance, so the carrier headcount minimum doesn't apply — B2B-2620. */
export const MIN_EMPLOYEES_FOR_APP_ONLY = 1;
